import Breadcrumbs from 'Components/Breadcrumbs'
import { WithLoader } from 'Components/WithLoader'
import SchoolCalendarForm from 'Services/ControlDataManagement/Features/SchoolCalendar/Components/SchoolCalendarForm'
import { SELECTED_SCHOOL_CALENDAR_PARAMETER_KEY } from 'Services/ControlDataManagement/Features/SchoolCalendar/Hooks/useSchoolCalendarsWithParams'
import { useGetSingleSchoolCalendarQuery } from 'Services/ControlDataManagement/Features/SchoolCalendar/schoolCalendarApi'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { CONTROL_DATA_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/system'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

function SchoolCalendarEditPage() {
  const { id } = useParams()

  const { data: calendar, isLoading } = useGetSingleSchoolCalendarQuery(id ?? '', {
    skip: !id
  })

  const baseUrl = `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/school-management/school-calendars/`
  const previousLocation = usePreviousLocation(
    `${baseUrl}?${SELECTED_SCHOOL_CALENDAR_PARAMETER_KEY}=${id}`
  )

  const breadcrumbs = [
    {
      title: t`Home`,
      link: '/control-data-management/'
    },
    {
      title: t`Calendars`,
      link: baseUrl
    },
    {
      title: t`Edit calendar`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={2}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>
        <SchoolCalendarForm successBaseUrl={previousLocation} schoolCalendar={calendar} />
      </WithLoader>
    </Box>
  )
}

export default SchoolCalendarEditPage
